import { styled } from '@mui/material/styles'
import TooltipMUI, { TooltipProps as TooltipMUIProps } from '@mui/material/Tooltip'
import { Theme } from '@mui/material'
import { css } from '@mui/styled-engine'
import { theme as newTheme } from 'styles/theme/hav-theme'

export type TooltipProps = TooltipMUIProps

export const Tooltip = styled(({ className, children, ...props }: TooltipProps) => (
  <TooltipMUI classes={{ popper: className }} {...props}>
    {children}
  </TooltipMUI>
))`
  ${({ theme }: { theme?: Theme }) =>
    theme &&
    css`
      filter: drop-shadow(${newTheme.effects.boxShadow['rule-01']});
      & .MuiTooltip-tooltip {
        background: ${newTheme.colors.neutral.white};
        color: ${newTheme.colors.neutral.high};
        font-family: ${newTheme.typography.family.primary};
        font-weight: ${newTheme.typography.weight.md};
        font-size: ${newTheme.typography.sizes['2xs']};
        max-width: 400px;
      }

      & .MuiTooltip-arrow {
        color: ${newTheme.colors.neutral.white};
      }
    `}
`
